"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../../KESI2/KESI2BasicComponent"));

var _QDQuestionEditorNugget = _interopRequireDefault(require("../../../../../KESI2/entities/nuggets/QDQuestionEditorNugget"));

var _ErvIAmSafeNugget = _interopRequireDefault(require("../../../../../KESI2/entities/nuggets/ErvIAmSafeNugget"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _index = _interopRequireDefault(require("../../../Button/index.js"));

var _config = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/config.js"));

var _QD_Kesi_ConnectChannel = require("../../../../../KESI2/Services/QD_Kesi_ConnectChannel");

var _AppChannel = require("../../../../../KESI2/Services/AppChannel");

var _AppUtils = require("../../../../../utils/AppUtils");

var _AblyMessagingCommands = require("../../../../constants/AblyMessagingCommands");

var _Spinner = _interopRequireDefault(require("../../../Spinner/Spinner"));

var _MuiAlertHelper = require("../../../../../helpers/MuiAlertHelper");

var _Nugget = _interopRequireDefault(require("../Nugget.scss"));

var _DrupalQDQuestionEditorNugget = _interopRequireDefault(require("./DrupalQDQuestionEditorNugget.scss"));

var _cssConstants = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _MessagingService = _interopRequireDefault(require("../../../../../KESI2/Services/MessagingService"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../../helpers/DeviceInfoHelper"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'qdQuestionEditorContainer_';

var DrupalQDQuestionEditorNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalQDQuestionEditorNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalQDQuestionEditorNugget);

  function DrupalQDQuestionEditorNugget(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalQDQuestionEditorNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handlePartnerActiveRequest", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (message.clientId === _this.state.partnerId) {
                  _this.setState({
                    partnerActive: false
                  });

                  _this.setState({
                    partnerId: ''
                  });
                } else {
                  _this.setState({
                    partnerActive: true
                  });

                  _this.setState({
                    partnerId: message.clientId
                  });

                  if (message.data.needId) {
                    (0, _AppChannel.sendMessage)(_AblyMessagingCommands.ABLY_COMMANDS.PARTNER_ACTIVE, {
                      needId: true
                    }, _this.state.partnerId);
                  }
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sendData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var question, game, questions;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.state.question) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return _this.parseData();

            case 4:
              question = _context2.sent;

              if (question) {
                _context2.next = 8;
                break;
              }

              (0, _MuiAlertHelper.showWideAlertHtml)('Die Frage hat ein falsches Format und konnte nicht geparsed werden', 'Error');
              return _context2.abrupt("return");

            case 8:
              game = {};
              game.rounds = [{}];
              questions = [];
              questions.push(question);
              game.rounds[0].questions = questions;
              (0, _AppChannel.sendMessage)(_AblyMessagingCommands.ABLY_COMMANDS.ROUND_DATA, {
                game: game
              }, _this.state.partnerId);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _this.state = _objectSpread({
      question: '',
      partnerActive: false,
      partnerId: ''
    }, _this.state);

    _this.props.registerNugget(_this.props.id, _QDQuestionEditorNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    return _this;
  }

  (0, _createClass2["default"])(DrupalQDQuestionEditorNugget, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.registerNuggetPosition(this.props.id, _ErvIAmSafeNugget["default"].CLASS, this.getDomId());
                (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.PARTNER_ACTIVE, this.handlePartnerActiveRequest);
                (0, _QD_Kesi_ConnectChannel.sendMessageToGroup)(_AblyMessagingCommands.ABLY_COMMANDS.PARTNER_ACTIVE, {});

                if (this.props.inListContainer) {
                  this.props.setBackButtonFunc(this.props.goUpFunc);
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalQDQuestionEditorNugget.prototype), "componentWillUnmount", this).call(this);
      (0, _AppUtils.unregisterFromAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.PARTNER_ACTIVE, this.handlePartnerActiveRequest);
    }
  }, {
    key: "parseData",
    value: function () {
      var _parseData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var questionData, question;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Todo maybe wait for one parse to finish before allowing another one (if user clicks on the parse button like crazy)
                questionData = this.state.question.replace(/^[?/].*/gm, '').replace(/^\s*$(?:\r\n?|\n)/gm, '');
                question = {};
                question.category = {
                  name: 'QuestionEditor'
                };
                question.answers = [];
                question.duration = 30;
                question.detailedFeedback = {};
                question.number = 0;
                console.log('QUESTIONDATA: ', questionData);
                _context4.prev = 8;

                if (!questionData.includes('#BEGIN MD')) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 12;
                return this.parseMarkdownData(question, questionData);

              case 12:
                _context4.next = 15;
                break;

              case 14:
                this.parseNormalData(question, questionData.split(/\n/));

              case 15:
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](8);
                console.log(_context4.t0);
                return _context4.abrupt("return", false);

              case 21:
                console.log('CONSTRUCTED QUESTION OBJECT:', question);

                if (!(question.answers.length !== 4)) {
                  _context4.next = 24;
                  break;
                }

                return _context4.abrupt("return", false);

              case 24:
                return _context4.abrupt("return", question);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 17]]);
      }));

      function parseData() {
        return _parseData.apply(this, arguments);
      }

      return parseData;
    }()
  }, {
    key: "parseNormalData",
    value: function parseNormalData(question, questionArr) {
      var j = 0;
      var i = 0;
      question.question = questionArr[0];

      for (i++; i < questionArr.length; i++) {
        if (questionArr[i].includes('-->')) {
          question.detailedFeedback[j - 1] = {
            html: questionArr[i].slice(3)
          };
        } else if (questionArr[i].includes('==>')) {
          question.feedback = questionArr[i].slice(3);
        } else if (questionArr[i][0] === '+') {
          question.answers.push({
            answer: questionArr[i].slice(1),
            isCorrect: true,
            number: j
          });
          j++;
        } else if (questionArr[i][0] === '-') {
          question.answers.push({
            answer: questionArr[i].slice(1),
            isCorrect: false,
            number: j
          });
          j++;
        }
      }
    }
  }, {
    key: "parseMarkdownData",
    value: function () {
      var _parseMarkdownData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(question, questionData) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var data = {};
                  var regex = /#BEGIN MD([\s\S]*?)#END MD/g;
                  var markdownArr = [];
                  var match = regex.exec(questionData);

                  while (match !== null) {
                    markdownArr.push(match[1]);
                    match = regex.exec(questionData);
                  }

                  data.question = markdownArr[0];
                  data.answers = markdownArr.slice(1, markdownArr.length);
                  var xhr = new window.XMLHttpRequest();
                  xhr.open('POST', 'http://127.0.0.1:3000', true);

                  xhr.onreadystatechange = function () {
                    if (xhr.status === 200 && xhr.readyState === 4) {
                      var _regex = /^(?:-->|==>).*/gm;
                      var feedbackArr = [];

                      var _match = _regex.exec(questionData);

                      while (_match !== null) {
                        feedbackArr.push(_match[0]);
                        _match = _regex.exec(questionData);
                      }

                      var correctnessArr = [];
                      _regex = /^(?:-|\+)(?!-)/gm;
                      _match = _regex.exec(questionData);

                      while (_match !== null) {
                        correctnessArr.push(_match[0]);
                        _match = _regex.exec(questionData);
                      }

                      if (correctnessArr.length !== 4) {
                        reject(new Error('correctnessArr has wrong size: ' + feedbackArr.length));
                      }

                      try {
                        var parsedResponse = JSON.parse(xhr.responseText);
                        question.question = parsedResponse.question;

                        for (var i = 0; i < parsedResponse.answers.length; i++) {
                          question.answers.push({
                            answer: parsedResponse.answers[i],
                            isCorrect: correctnessArr[i] === '+',
                            number: i
                          });
                        }
                      } catch (e) {
                        reject(e);
                      }

                      if (feedbackArr.length === 1) {
                        question.feedback = feedbackArr[0];
                      } else if (feedbackArr.length === 4) {
                        for (var _i = 0; _i < feedbackArr.length; _i++) {
                          question.detailedFeedback[_i] = {
                            html: feedbackArr[_i].slice(3)
                          };
                        }
                      } else {
                        reject(new Error('feedback array has wrong size: ' + feedbackArr.length));
                      }

                      resolve(question);
                    }
                  };

                  xhr.onerror = function () {
                    console.log('an error has occured while trying to send markdown data');
                    reject(new Error('an error has occured while trying to send markdown data'));
                  };

                  console.log('sending markdown data');
                  xhr.send((0, _stringify["default"])(data));
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function parseMarkdownData(_x2, _x3) {
        return _parseMarkdownData.apply(this, arguments);
      }

      return parseMarkdownData;
    }() // ToDo: style items in sync with current kesi config

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.state.partnerActive) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "htmlContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer),
          id: this.getDomId(),
          style: this.props.inSwipeContainer ? {
            width: '100%',
            padding: 0,
            margin: 0
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_Nugget["default"].container)
        }, /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            textAlign: 'center',
            marginBottom: '10%'
          }
        }, "No partner is currently available"), /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)));
      }
      /**
       **
       * @type {HtmlNugget}
       *
       */


      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "htmlContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer),
        id: this.getDomId(),
        style: this.props.inSwipeContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'title'
      }, "Questfile Input"), /*#__PURE__*/_react["default"].createElement("textarea", {
        style: {
          width: '100%',
          marginTop: '1%'
        },
        id: 'qestInput',
        rows: 30,
        onChange: function onChange(e) {
          return _this2.setState({
            question: e.target.value
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _DrupalQDQuestionEditorNugget["default"].editButton,
        onClick: function onClick(e) {
          return _this2.sendData();
        }
      }, "Preview")));
    }
  }]);
  return DrupalQDQuestionEditorNugget;
}(_KESI2BasicComponent["default"]);

var _default = DrupalQDQuestionEditorNugget;
exports["default"] = _default;